var map = {
	"./Apple2.png": 54784,
	"./Ball2.png": 57182,
	"./Banana2.png": 7957,
	"./Bird.png": 90945,
	"./Books.png": 84534,
	"./Bus.png": 75522,
	"./Cars.png": 77492,
	"./CarsAndBicycle.png": 21563,
	"./Cat2.png": 87719,
	"./Circle.png": 10862,
	"./Dog.png": 43698,
	"./Flower2.png": 83646,
	"./Grapes.png": 20246,
	"./Orange.png": 42141,
	"./Pear.png": 53813,
	"./Pineapple.png": 11866,
	"./Square.png": 56826,
	"./Triangle.png": 23938,
	"./apple.png": 81119,
	"./baby.png": 98665,
	"./ball.png": 45930,
	"./banana.png": 95074,
	"./bed.png": 48798,
	"./bicycle.png": 65364,
	"./boat.png": 49700,
	"./book.png": 64004,
	"./boot.png": 2243,
	"./cat.png": 30090,
	"./chair.png": 75254,
	"./check.png": 18840,
	"./cow.png": 85019,
	"./crocodile.png": 15593,
	"./cross.png": 84377,
	"./cup.png": 85791,
	"./doll.png": 71688,
	"./dysmate-logo-hvit-small.png": 64222,
	"./ear.png": 11446,
	"./elephant.png": 27407,
	"./eye.png": 86339,
	"./finger.png": 27879,
	"./fireengine.png": 69837,
	"./fish.png": 32405,
	"./flower.png": 73758,
	"./flowers.png": 52940,
	"./foot.png": 83041,
	"./gloves.png": 52388,
	"./horse.png": 73023,
	"./house.png": 45202,
	"./house2.png": 21039,
	"./icecream.png": 51353,
	"./jeans.png": 57109,
	"./key.png": 67986,
	"./laptop-icon.png": 62295,
	"./lion.png": 98986,
	"./literate-regular-light.png": 81506,
	"./logo-white.png": 36286,
	"./motorcycle.png": 12180,
	"./norming/rapidNaming/eple_bla-min.png": 94688,
	"./norming/rapidNaming/eple_brown-min.png": 39977,
	"./norming/rapidNaming/eple_gronn-min.png": 10954,
	"./norming/rapidNaming/eple_gul-min.png": 20747,
	"./norming/rapidNaming/eple_red-min.png": 33472,
	"./norming/rapidNaming/kake_blue-min.png": 89756,
	"./norming/rapidNaming/kake_brown-min.png": 27381,
	"./norming/rapidNaming/kake_green-min.png": 95863,
	"./norming/rapidNaming/kake_red-min.png": 37778,
	"./norming/rapidNaming/kake_yellow-min.png": 66206,
	"./norming/rapidNaming/moon_blue-min.png": 93193,
	"./norming/rapidNaming/moon_brown-min.png": 54697,
	"./norming/rapidNaming/moon_green-min.png": 1965,
	"./norming/rapidNaming/moon_red-min.png": 83022,
	"./norming/rapidNaming/moon_yellow-min.png": 17109,
	"./norming/rapidNaming/star_green-min.png": 6547,
	"./norming/rapidNaming/stjerne_blue-min.png": 57113,
	"./norming/rapidNaming/stjerne_brown-min.png": 79485,
	"./norming/rapidNaming/stjerne_gul-min.png": 4184,
	"./norming/rapidNaming/stjerne_red-min.png": 28522,
	"./norming/rapidNaming/sykkel-blue-min.png": 3724,
	"./norming/rapidNaming/sykkel_blå-min.png": 64983,
	"./norming/rapidNaming/sykkel_brown-min.png": 56570,
	"./norming/rapidNaming/sykkel_gronn-min.png": 53853,
	"./norming/rapidNaming/sykkel_gul-min.png": 65502,
	"./norming/rapidNaming/sykkel_red-min.png": 72685,
	"./nose.png": 16889,
	"./package.png": 98558,
	"./pc-icon.png": 70792,
	"./plane.png": 38975,
	"./plowtruck.png": 17391,
	"./porrige.png": 75300,
	"./purse.png": 24996,
	"./rabbit.png": 11538,
	"./rapidNaming/bamse.png": 82150,
	"./rapidNaming/blabamse.png": 32769,
	"./rapidNaming/blaeple.png": 6822,
	"./rapidNaming/blagenser.png": 44555,
	"./rapidNaming/blasykkel.png": 80626,
	"./rapidNaming/blatommel.png": 52903,
	"./rapidNaming/elefant.png": 75745,
	"./rapidNaming/eple.png": 31510,
	"./rapidNaming/genser.png": 26023,
	"./rapidNaming/grabamse.png": 95929,
	"./rapidNaming/graeple.png": 1869,
	"./rapidNaming/gragenser.png": 87552,
	"./rapidNaming/grasykkel.png": 55636,
	"./rapidNaming/gratommel.png": 86818,
	"./rapidNaming/gronnbamse.png": 68760,
	"./rapidNaming/gronneple.png": 74529,
	"./rapidNaming/gronngenser.png": 70936,
	"./rapidNaming/gronnsykkel.png": 47051,
	"./rapidNaming/gronntommel.png": 68559,
	"./rapidNaming/oransjebamse.png": 17676,
	"./rapidNaming/oransjeeple.png": 60032,
	"./rapidNaming/oransjegenser.png": 32923,
	"./rapidNaming/oransjesykkel.png": 26353,
	"./rapidNaming/oransjetommel.png": 99283,
	"./rapidNaming/paraply.png": 20440,
	"./rapidNaming/prinsesse.png": 79646,
	"./rapidNaming/rodbamse.png": 86929,
	"./rapidNaming/rodeple.png": 91597,
	"./rapidNaming/rodgenser.png": 58067,
	"./rapidNaming/rodsykkel.png": 54615,
	"./rapidNaming/rodtommel.png": 37916,
	"./rapidNaming/stoevsuger.png": 75067,
	"./rapidNaming/sykkel.png": 82670,
	"./rapidNaming/tannboerste.png": 79073,
	"./rapidNaming/tommel.png": 91193,
	"./reflex.png": 69256,
	"./saft.png": 38504,
	"./server-icon.png": 26264,
	"./shoe.png": 61837,
	"./ski.png": 6994,
	"./spoon.png": 77050,
	"./sun.png": 21932,
	"./sweater.png": 26643,
	"./teddy.png": 41334,
	"./telephone.png": 72185,
	"./tractor.png": 69941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;